import './DeleteSubClient.css';
import { deleteSubClient } from '../../utilities/api/subClients';
import { useEffect, useRef, useState } from 'react';

export default function DeleteSubClient({user, subClient, updateSubClients, toggleNotifications}) {
    const [isDeleting, setIsDeleting] = useState(false);
    const isMountedRef = useRef(true);


    const handleDeleteSubClient = async () => {
        if (!isMountedRef.current) return;
        try {
            setIsDeleting(true);
            await deleteSubClient(user._id, subClient._id);
            if (isMountedRef.current) {
                await updateSubClients((prevSubClients) => {
                    return prevSubClients.filter((sc) => sc._id !== subClient._id);
                });
                toggleNotifications('success', 'Sub-client deleted successfully', "#FFFFFF");
            }
        } catch (error) {
            console.error('Error deleting sub-client:', error);
            toggleNotifications('error', 'Error deleting sub-client', "#FFFFFF");
        } finally {
            if (isMountedRef.current) {
                setIsDeleting(false);
            }
        }
    }

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

  return (
    <div className='DeleteSubClient'>
        <button className='deleteButton' onClick={handleDeleteSubClient} disabled={isDeleting}>
            Delete
        </button>
    </div>
  )
}
